import Grid from "@mui/material/Grid";
import React from "react";
import { useForm } from "../../../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import HighlightBox from "../../../../Box/HighlightBox/HighlightBox";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import MuiListNativeStyled from "../../../../List/MuiListNativeStyled";
import objectionConsequencesStyle from "./ObjectionConsequencesStyle";

type LawsuitConsequencesProps = {
  product: AbstractCase;
};

const ObjectionConsequences = ({ product }: LawsuitConsequencesProps) => {
  const { values } = useForm();

  if (values.administrativeDecisionFeedbackClient !== "objection") {
    return null;
  }

  return (
    <Grid sx={{ marginBottom: 2 }} size={12}>
      <HighlightBox textColor={"defaultText"} textAlign={"center"}>
        <Typography>Bitte beachten Sie für das weitere Vorgehen folgende Aspekte:</Typography>
        <br />

        <MuiListNativeStyled
          sx={objectionConsequencesStyle.listStyle}
          listItems={[
            <>
              <strong>Dauer des Verfahrens:</strong> Auch ein außergerichtliches Widerspruchsverfahren kann sich in die Länge ziehen. Die Bearbeitungszeiten bei
              Behörden und Dienstherren variieren stark, sodass bis zur Entscheidung über Ihren Widerspruch durchaus einige Monate vergehen können. Eine
              Beschleunigung des Verfahrens ist hier oft nur begrenzt möglich.
            </>,
            <>
              <strong>Schriftliches Verfahren:</strong> Das Verfahren wird rein schriftlich geführt. Es finden keine mündlichen Verhandlungen statt, sodass Ihre
              persönliche Anwesenheit (anders als später vor Gericht) nicht erforderlich ist und Sie hierfür keinen Urlaub nehmen müssen.
            </>,
            <>
              <strong>Weiteres Vorgehen:</strong> Sollte der Dienstherr dem Widerspruch nicht abhelfen, erhalten Sie einen Widerspruchsbescheid. Dieser ist die
              zwingende Voraussetzung für eine spätere Klage. Ob dieser gerichtliche Schritt notwendig und sinnvoll ist, entscheiden wir gemeinsam nach
              Abschluss dieses Verfahrens.
            </>,
          ]}
        />
      </HighlightBox>
    </Grid>
  );
};
export default ObjectionConsequences;
